module.exports = __webpack_public_path__ + "img/pexels-tiger-lily-4483610.5a926628.jpg";